import React from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import styles from './Banner.module.sass';
import BREAKPOINTS from '../../constants/breakpoints';

function Banner(props) {
  const { color, image } = props;
  return (
    <MediaQuery query={`(min-width: ${BREAKPOINTS.DESKTOP_WIDTH_BREAKPOINT}px)`}>
      <div className={styles.banner}>
        <div className={styles.image}>
          <img src={image} alt="" />
        </div>
        <div className={styles['text-block']} style={color ? { background: color } : null}>
          <div className={styles.content}>
            <div className={styles.title}>
              Submit an Idea
            </div>
            <div className={styles.description}>
              Become a
              <br />
              Volition
              <br />
              Beauty
              <br />
              Innovator
            </div>
            <div className={styles.letter}>
              V
            </div>
          </div>
        </div>
      </div>
    </MediaQuery>
  );
}

Banner.propTypes = {
  color: PropTypes.string,
  image: PropTypes.shape({}).isRequired,
};

export default Banner;
